import type { Product } from './types';

/** Moves discontinued products after the current ones, keeping each group's existing order. */
export function sortDiscontinuedLast<T extends Pick<Product, 'discontinued'>>(products: T[]): T[] {
  return [...products.filter((p) => !p.discontinued), ...products.filter((p) => p.discontinued)];
}
